import React, { useEffect, useRef } from 'react';
import { EXTERNAL_LINKS } from 'app/routing/registration';
import { ENV } from 'config';
import LocaleService from 'modules/Localization';
import { Link } from '@upstox/upstox-ui';

export const LearnMoreAboutChartSaveLink = () => {
  const ref = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    if (ref.current) {
      // setting the target as _blank using ref,
      // becuase the ui package accepts the target prop but doesnot apply it to the "a" tag.
      ref.current.target = '_blank';
    }
  }, []);

  return (
    <Link
      href={EXTERNAL_LINKS.CHART_SAVE_HELP_LINK[ENV]}
      rel="noopener noreferrer"
      as="a"
      tabIndex={-1}
      ref={ref}
    >
      {LocaleService.translate('LEARN_MORE')}
    </Link>
  );
};
